import React from 'react';
import { Users, Target, Heart } from 'lucide-react';
import Card3D from './ui/Card3D';
import SectionBackground from './ui/SectionBackground';
import { colors } from '../styles/theme';

const About: React.FC = () => {
  return (
    <section id="about" className="relative py-20 bg-gray-50">
      <SectionBackground variant="both" color={colors.tertiary} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">À propos de nous</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez notre engagement pour un avenir numérique inclusif et accessible à tous les étudiants.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Users className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Notre Mission</h3>
              <p className="text-gray-600">
                Réduire la fracture numérique et assurer l'égalité des chances pour tous les étudiants.
              </p>
            </div>
          </Card3D>

          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Target className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Notre Vision</h3>
              <p className="text-gray-600">
                Un monde où chaque étudiant a accès aux outils numériques nécessaires à sa réussite.
              </p>
            </div>
          </Card3D>

          <Card3D>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow h-full">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Heart className="h-6 w-6 text-[#0139B7]" />
              </div>
              <h3 className="text-xl font-bold mb-4">Nos Valeurs</h3>
              <p className="text-gray-600">
                Solidarité, innovation et engagement pour un impact social positif.
              </p>
            </div>
          </Card3D>
        </div>
      </div>
    </section>
  );
};

export default About;